export default function getBasketBindingApiKeyFromCookie() {
  return document.cookie
    .split('; ')
    .find(row => row.startsWith('basket_binding_api_key='))
    ?.split('=')[1];
}
